export function createFlushContext(schedule = queueMicrotask) {
    return {
        pendingUpdates: new Set(),
        flushListeners: new Set(),
        postCommitTasks: new Set(),
        flushScheduled: false,
        isFlushing: false,
        scheduler: schedule,
        disposed: false,
    };
}
export const defaultFlushContext = createFlushContext();
//# sourceMappingURL=flush-context.js.map